@if (permissionService.isWaitingSpinner()) {
    @if(permissionService.isUserAuthenticated()) {
        <div class="text-center bg-light" style="position: fixed; z-index: 2; width: 100vw; height: 100vh; opacity: 0.85">
            <!-- <img src="/assets/images/caroleo_logo_blue.svg" class="spinner_buildings"> -->
            <svg width="35" height="35" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="margin-top: calc(50vh - 35px)"><path class="spinner_standard" d="M2,12A11.2,11.2,0,0,1,13,1.05C12.67,1,12.34,1,12,1a11,11,0,0,0,0,22c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"/></svg>
        </div>
    }
    @else {
        <div class="text-center bg-light" style="position: fixed; z-index: 2; width: 100vw; height: 100vh; opacity: 0.85">
            <img src="/assets/images/caroleo_logo_blue.svg" class="spinner_buildings">
        </div>
    }
}
@if (permissionService.isUserAuthenticated()) {
    <img src="/assets/images/caroleo_logo_blue.svg" style="position: fixed; z-index: -1; opacity: 0.03; width: 60vh; height: 60vh; margin-top: calc( ( (100vh - 60vh - 86px - 50px) / 2) + 86px); margin-left: 9vw; overflow: visible;">
    <app-header></app-header>
    <main class="main main_height_private">
        <router-outlet></router-outlet>
    </main>
}
@else {
    <img src="/assets/images/caroleo_logo_blue.svg" style="position: fixed; z-index: -1; opacity: 0.05; width: 70vh; height: 70vh; margin-top: calc( ( (100vh - 70vh - 32.774px - 3vh - 50px) / 2) + 32.524px + 3vh); margin-left: 7vw; overflow: visible;">
    <main class="main main_height_public">
        <h2 class="text-primary" style="padding: 3vh 0 0 4rem; margin: 0;"><a routerLink="/login" class="text-decoration-none text-primary">Servizi tecnici</a></h2>
        <div class="row mt-4 mx-0 p-0">
            <div class="col offset-0 col-11 offset-sm-0 col-sm-9 offset-md-2 col-md-6 offset-lg-4 col-lg-5 offset-xl-5 col-xl-4 offset-xxl-5 col-xxl-3 ps-0">
                <h2 class="text-end text-primary">Studio Geometra</h2> 
            </div>
        </div>
        <div class="row mx-0">
            <div class="col offset-0 col-11 offset-sm-0 col-sm-9 offset-md-2 col-md-6 offset-lg-4 col-lg-5 offset-xl-5 col-xl-4 offset-xxl-5 col-xxl-3 ps-0">
                <h1 class="text-end text-primary">Luca Caroleo</h1>
            </div>
        </div>
        <router-outlet></router-outlet>
    </main>
}
<app-footer></app-footer>

<!--------------------------------------------------- Standard Modal
    <button hidden="true" #openModalStandardButton data-bs-toggle="modal" data-bs-target="#modalStandard"></button>

    <div class="modal fade p-3" id="modalStandard" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content text-primary bg-light border border-1 border-primary">
                <div class="modal-body">
                    <div class="row m-3">
                        {{modalMessage()}}
                    </div>
                    <hr>
                    <div class="row text-center">
                        <div class="col col-6">
                            @if (modalType() === 'confirm') {
                                <a class="btn py-0">
                                    <span class="bi-x-square-fill text-secondary fs-2" data-bs-dismiss="modal" (click)="permissionService.setModalOutput(false)"></span>
                                </a>
                            }
                        </div>
                        <div class="col col-6" [class]="modalType() === 'alert' ? 'text-end ps-0 pe-5' : ''">
                            <a class="btn py-0">
                                <span class="bi-check-circle-fill text-success fs-2" data-bs-dismiss="modal" (click)="permissionService.setModalOutput(true)"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
FINE Standard Modal ------------------------------------------------>

<!------------ New Standard alert & confirmation pupup -------------->
@if (popupType() === 'confirm' || popupType() === 'alert') {
    <div class="custom-backdrop">
        <div class="custom-popup">
            <div class="row m-3">
                {{popupMessage()}}
            </div>
            <hr>
            <div class="row text-center">
                <div class="col col-6">
                    @if (popupType() === 'confirm') {
                        <a class="btn py-0">
                            <span class="bi-x-square-fill text-secondary fs-2" (click)="permissionService.setPopupOutput(false)"></span>
                        </a>
                    }
                </div>
                <div class="col col-6" [class]="popupType() === 'alert' ? 'text-end ps-0 pe-5' : ''">
                    <a class="btn py-0">
                        <span class="bi-check-circle-fill text-success fs-2" (click)="permissionService.setPopupOutput(true)"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
}
<!------------ End Standard alert & confirmation pupup -------------->


<!------------ Cookie policy Modal -------------->
<button hidden="true" #openModalCookiePolicyButton data-bs-toggle="modal" data-bs-target="#modalCookiePolicyId"></button>

<div class="modal modal-lg fade" data-bs-backdrop="static" id="modalCookiePolicyId">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable px-2 my-0 mt-5">
        <div class="modal-content text-bg-primary">
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row mx-2 mt-2">
                    <div class="col p-0 z-1">
                        <h4 class="text-center">Consenso all'uso dei cookie</h4>
                    </div>
                </div>
                <div class="row mx-2 mt-2">
                    <div class="col">
                        <span class="fs-6">
                            Questo sito utilizza esclusivamente cookie tecnici propedeutici al corretto funzionamento del servizio.<br><br>
                            Non viene fatto uso di cookie di profilazione per scopi di marketing.<br><br>
                            Per maggiori informazioni consulta la pagina <a type="button" class="text-decoration-underline text-light" data-bs-target="#modalCookiePolicyId" data-bs-dismiss="modal" (click)="cookesPolicy()">cookie policy</a>
                        </span>
                    </div>
                </div>
                <div class="row mx-2 mt-3">
                    <div class="col text-center">
                        <button type="button" data-bs-target="#modalCookiePolicyId" data-bs-dismiss="modal" class="btn btn-primary link-light text-bg-success position-relative" (click)="acceptCookies()">ho letto</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!------------ End Cookie policy Modal -------------->
